import { defineMessages } from "react-intl";

export default defineMessages({
  btnSendCode: {
    id: "Patient.PatientEditForm.btnSendCode",
    defaultMessage: "Send confirmation code",
  },
});
